var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerEventoNegro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.669,
    height: 91.669,
    viewBox: "0 0 91.669 91.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_92",
    "data-name": "Grupo 92",
    transform: "translate(-3023.237 -388.331)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_67",
    "data-name": "Rect\\xE1ngulo 67",
    width: 91.669,
    height: 91.669,
    transform: "translate(3114.905 480) rotate(180)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "ver_evento",
    "data-name": "ver  evento",
    transform: "translate(3032.648 458.401)",
    fill: "#fff",
    fontSize: 20.107,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ver "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13.955
  }, "evento")), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67",
    "data-name": "Grupo 67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_97",
    "data-name": "Trazado 97",
    d: "M3044.979,398.007v11.166h-11.167",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_16",
    "data-name": "L\\xEDnea 16",
    x2: 11.056,
    y2: 11.056,
    transform: "translate(3033.924 398.118)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerEventoNegro);
export default __webpack_public_path__ + "static/media/verEventoNegro.6cc10446350d4a3d41c285cf36e15bb8.svg";
export { ForwardRef as ReactComponent };